export { FocusTrapWrapper } from './focus-trap-wrapper';
export type { FocusTrapWrapperProps } from './models';
